import React from 'react';
import { useDisclosure } from 'Src/hooks/use-disclosure/useDisclosure';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { usePledgSchedule } from './usePledgSchedule';
import { PledgTimelinesModal } from './PledgTimelinesModal';

export const PledgPrice = ({
  price,
  label,
  iconClassname,
}: {
  price: Price;
  label?: string;
  iconClassname: string;
}) => {
  const { monthlyPayment, fees, firstPayment, installment } = usePledgSchedule({ price });
  const { isOpen, onClose, onOpen } = useDisclosure();

  const isSinglePrice = !label;

  return (
    <React.Fragment>
      <span className="none cursor-pointer text-14" role="button" aria-hidden="true">
        <TemplateString
          template={label || '{monthlyPayment}'}
          valuesClassName={{
            firstPayment: 'font-bold text-sienna',
            monthlyPayment: classnames({
              ['font-bold text-sienna']: !isSinglePrice,
              ['text-12']: isSinglePrice,
            }),
            fees: 'font-bold text-sienna',
          }}
          values={{ firstPayment, monthlyPayment, fees }}
        />
        <span
          className={classnames('absolute', iconClassname)}
          onClick={(e) => {
            e.preventDefault();
            onOpen();
          }}
        >
          <Icon
            name={ICONS.INFORMATION}
            width="1.5rem"
            className={classnames({
              ['text-sienna']: !isSinglePrice,
            })}
          />
        </span>
      </span>
      {isOpen && (
        <PledgTimelinesModal onCloseModal={onClose} installment={installment} total={price} />
      )}
    </React.Fragment>
  );
};
